import { render, staticRenderFns } from "./MoveInputNumber.vue?vue&type=template&id=8984c5d8&scoped=true&"
import script from "./MoveInputNumber.vue?vue&type=script&lang=js&"
export * from "./MoveInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./MoveInputNumber.vue?vue&type=style&index=0&id=8984c5d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8984c5d8",
  null
  
)

export default component.exports